export const CHART_VIEWS = {
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
} as const;

export type CHART_VIEW = (typeof CHART_VIEWS)[keyof typeof CHART_VIEWS];
